<template>
  <div class="wrap">
    <router-link to="/diagnosis_stock">
      <div class="openDiagnosis"></div>
    </router-link>
    <router-link to="/found_winners">
      <div class="winners_diagnosis"></div>
    </router-link>

  </div>
</template>

<script>
    export default {
        name: "WinnersDiagnosis"
    }
</script>

<style scoped>
  .wrap{
    width: 100%;
    height: 677px;
    background: url("../assets/img/winners_diagnosis.png");
    /*background-position: center;*/
    position: relative;
  }
  .openDiagnosis{
    width: 320px;
    height: 350px;
    position: absolute;
    top: 80px;
    left: 610px;
    transform:rotate(-5deg);
    -ms-transform:rotate(-5deg); 	/* IE 9 */
    -moz-transform:rotate(-5deg); 	/* Firefox */
    -webkit-transform:rotate(-5deg); /* Safari 和 Chrome */
    -o-transform:rotate(-5deg); 	/* Opera */
  }
  .winners_diagnosis{
    width: 320px;
    height: 350px;
    position: absolute;
    top: 100px;
    left: 1050px;
    transform:rotate(5deg);
    -ms-transform:rotate(5deg); 	/* IE 9 */
    -moz-transform:rotate(5deg); 	/* Firefox */
    -webkit-transform:rotate(5deg); /* Safari 和 Chrome */
    -o-transform:rotate(5deg); 	/* Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/WinnersDiagnosis.vue